import { createNavigationContainerRef } from '@react-navigation/native'
import { MutableRefObject, createRef } from 'react'

import { RootStackParamList } from '../navigation'

export const navigationRef = createNavigationContainerRef<RootStackParamList>()

export const isMountedRef: MutableRefObject<boolean | null> = createRef()
